import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CheckUserExistByPhoneQueryResponse, CheckUserExistByPhoneQueryParams } from "../../types/CheckUserExistByPhone";

/**
     * @summary Проверка существования пользователя по телефону
     * @link /api/user_check-exist
     */
export async function checkUserExistByPhone (params: CheckUserExistByPhoneQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<CheckUserExistByPhoneQueryResponse>["data"]> {
    const { data: resData } = await client<CheckUserExistByPhoneQueryResponse>({
        method: "get",
        url: `/api/user_check-exist`,
        params,
        ...options
    });
    
    return resData;
};